import { Col, Text } from 'components';
import { theme } from 'lib';

/**
 * One panel of the GloryBoard's working area.
 *
 * Adjusting a balance and reading what has already been adjusted sit side by side, so the two have
 * to read as two things rather than as one long column — the card is what separates them. Both
 * stretch to the taller of the pair so the row does not end ragged, and `minWid="0"` is what lets
 * a card actually narrow to its share of the row instead of being held open by its own contents.
 *
 * `start` is not decoration: Col's default `justify-content` is `center`, which in a stretched card
 * floats the contents into the middle and — where the contents scroll — pushes the first row out of
 * the top, somewhere no amount of scrolling reaches.
 *
 * The border goes through `style` rather than Col's `hasBorder`, whose declaration is emitted
 * without a trailing semicolon and so swallows whatever rule follows it.
 */
const GloryBoardCard = ({ title, subtitle, children, ...rest }) => (
  <Col
    start
    stretch
    minWid="0"
    pad="20px"
    bg={theme.PRIMARY_WHITE}
    hasRadius="14px"
    style={{ border: `1px solid ${theme.GREY_20}`, boxSizing: 'border-box' }}
    {...rest}
  >
    <Text h4 bold>
      {title}
    </Text>

    {subtitle && (
      <Text c1 col={theme.GREY_60} marg="4px 0 0">
        {subtitle}
      </Text>
    )}

    <Col start marg="16px 0 0" wid="100%" minWid="0">
      {children}
    </Col>
  </Col>
);

export default GloryBoardCard;
